// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueScroller from 'vue-scroller'
import axios from 'axios'
import store from './store'
import $sso from "./commons/utils/sso.js";
import LINKTYPE from "./commons/utils/linktype.js";

//import './assets/css/common.css';

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.interceptors.request.use(config=>{
  store.commit('setState',{
    isShowLoading: 1
  })
  return config
},err=>{
  return Promise.reject(err)
})
axios.interceptors.response.use(response=>{
  store.commit('setState',{
    isShowLoading: 0
  })
  return response
},err=>{
  if(err.response.status==401){
    $sso.login({ linkFrom: LINKTYPE.GOBACK });
  }
  return Promise.reject(err)
})
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(VueScroller)

//
router.beforeEach((to, from, next) => {

	var cul=window.location.href;

	if(cul.split("token=").length>1){

		var tk=cul.split("token=")[1].split("&")[0];
		if(tk!=""){

			localStorage.setItem("access_token",tk);
		}

		store.commit('setState',{access_token: tk });

	}

	if(cul.split("memberGroup=").length>1){

		var gp = cul.split("memberGroup=")[1].split("&")[0];
		if(gp!=""){

			localStorage.setItem("member_group",gp);
		}

	}


    next();

});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js